class TruncateElement extends HTMLElement {
  static get observedAttributes () {
    return ['line-clamp']
  }

  constructor () {
    super()
    this.attachShadow({ mode: 'open' })
    this.shadowRoot.innerHTML = `
      <style>
        .sha-Truncate {
          position: relative;
          overflow: hidden;
          height: var(--truncate-height);
          transition: height 0.3s ease;
        }

        .sha-Truncate.sha-Truncate_Expanded {
          height: var(--truncate-height-expanded);
        }

        @media (min-width: 768px) {
          .sha-Truncate {
            height: auto;
          }
          .sha-Truncate.sha-Truncate_Expanded {
            height: auto;
          }
        }
      </style>
      <div class="sha-Truncate">
        <slot></slot>
      </div>
    `

    this.truncateEl = this.shadowRoot.querySelector('.sha-Truncate')
    this.triggers = this.querySelectorAll('[data-truncate-element-trigger]')
    this.readMore = this.querySelector('[data-truncate-read-more]')
    this.readLess = this.querySelector('[data-truncate-read-less]')
    this.truncateInnerEl = this.querySelector('[data-truncate-element-content]')
    this.truncateInnerRect = null
    this.lineClamp = this.getAttribute('line-clamp') || '2'
    this.mediaQuery = window.matchMedia('(max-width: 767px)')
  }

  connectedCallback () {
    this.handleMediaQuery(this.mediaQuery)
    this.mediaQuery.addEventListener('change', this.handleMediaQuery.bind(this))

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        if (this.truncateEl.classList.contains('sha-Truncate_Expanded')) {
          this.close()
          this.readMore.style.display = 'inline-block'
          this.readLess.style.display = 'none'
        } else {
          this.open()
          this.readMore.style.display = 'none'
          this.readLess.style.display = 'inline'
        }
      })
    })

    this.setInitialHeight()
  }

  disconnectedCallback () {
    this.mediaQuery.removeEventListener(
      'change',
      this.handleMediaQuery.bind(this),
    )
  }

  handleMediaQuery (e) {
    if (!e.matches) {
      // Reset to default state when viewport is >= 768px
      this.truncateEl.classList.remove('sha-Truncate_Expanded')
      this.truncateInnerEl.style.setProperty('--line-clamp', 'none')
      this.triggers.forEach(trigger => {
        trigger.style.display = 'none'
      })
    } else {
      // Apply truncation when viewport is < 768px
      this.truncateInnerEl.style.setProperty('--line-clamp', this.lineClamp)
      this.readMore.style.display = 'inline-block'
      this.setInitialHeight()
    }
  }

  setInitialHeight () {
    const truncateRect = this.truncateEl.getBoundingClientRect()
    this.truncateEl.style.setProperty(
      '--truncate-height',
      `${truncateRect.height}px`,
    )
  }

  open () {
    this.truncateInnerEl.style.setProperty('--line-clamp', 'none')

    window.requestAnimationFrame(() => {
      this.truncateInnerRect = this.truncateInnerEl.getBoundingClientRect()
      this.truncateEl.style.setProperty(
        '--truncate-height-expanded',
        `${this.truncateInnerRect.height}px`,
      )
      this.truncateEl.classList.add('sha-Truncate_Expanded')
    })
  }

  close () {
    this.truncateEl.classList.remove('sha-Truncate_Expanded')

    setTimeout(() => {
      this.truncateInnerEl.style.setProperty('--line-clamp', this.lineClamp)
    }, 300)
  }
}

customElements.define('truncate-element', TruncateElement)
